import { formatMoney } from "@api/money";
import Order from "@api/types/order";
import React, { FC, MouseEventHandler } from "react";

import OrderHistoryOrder from "@components/OrderHistoryOrder";
import { InfoSpan, PrimaryInfo } from "@components/OrderHistoryTable/styles";

const OrderHistoryListItem: FC<{
  order: Order;
  visible: boolean;
  onClick: MouseEventHandler<HTMLElement>;
}> = ({ order, visible, onClick }) => {
  return (
    <>
      <li className="OrderHistoryListItem">
        <PrimaryInfo onClick={onClick}>
          <InfoSpan>{order.orderNumber}</InfoSpan>
          <InfoSpan>{order.date}</InfoSpan>
          <InfoSpan>{order.status.title}</InfoSpan>
          <InfoSpan>{order.poNumber}</InfoSpan>
          <InfoSpan>{formatMoney(order.total)}</InfoSpan>
        </PrimaryInfo>
        <OrderHistoryOrder order={order} visible={visible} />
      </li>
      {/* language=CSS */}
      <style jsx>
        {`
          .OrderHistoryListItem {
            background-color: ${visible ? "rgb(244, 243, 243)" : "rgb(255, 255, 255)"};
            border-bottom: 1px solid rgb(194, 194, 194);
            list-style: none;
            text-align: center;
          }
        `}
      </style>
    </>
  );
};

export default OrderHistoryListItem;
